var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { "data-test": _vm.CypressTarget("MyEventsRescuableEvents") } },
    [
      _vm.loading.events
        ? _c("skeleton-event-list")
        : !_vm.eventArray.length && !_vm.loading.events
        ? _c("sad-empty-error", {
            attrs: { text: _vm.$t("error.page.rescuableEvents") },
            on: { update: _vm.loadMore }
          })
        : _c(
            "q-pull-to-refresh",
            { attrs: { handler: _vm.pullToRefresh } },
            [
              _c("active-subscription-list-event-grid", {
                attrs: {
                  "event-list": _vm.eventArray,
                  "card-display": _vm.cardDisplay,
                  "to-name": "subscriptionRescuableEventInformation"
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }